import { z } from 'zod';

export const FeatureUsagePeriodSchema = z.enum(['7d', '30d']);

export type FeatureUsagePeriod = z.infer<typeof FeatureUsagePeriodSchema>;

/** Rate in percent of the surface's active users, trend in percentage points. */
const AdoptionSchema = z.object({ rate: z.number(), trend: z.number() });

const FeatureUsageEventSchema = AdoptionSchema.extend({
  name: z.string(),
  count: z.number(),
  /** YYYY-MM-DD, null when not fired in the 90-day lookback */
  lastFiredOn: z.string().nullable(),
  status: z.enum(['firing', 'never_fired', 'new']),
  params: z.array(
    z.object({
      name: z.string(),
      /** false when the param is no custom dimension in GA, so it cannot be split */
      registered: z.boolean(),
      values: z.array(z.object({ value: z.string(), share: z.number() })),
    }),
  ),
});

export const FeatureUsageSchema = z.object({
  period: FeatureUsagePeriodSchema,
  fetchedAt: z.string(),
  features: z.array(
    AdoptionSchema.extend({ id: z.string(), events: z.array(FeatureUsageEventSchema) }),
  ),
});

export type FeatureUsage = z.infer<typeof FeatureUsageSchema>;
